/*
 * Beaute Plus fade slideshow controller
 *
 * Dawn's stock SlideshowComponent advances slides by horizontally
 * scrolling the slider container, then reacts to scroll events to
 * update aria-hidden and the active dot. We override the visual with
 * an absolute-stacked fade in beauteplus-slideshow.css, but that
 * makes the container un-scrollable — Dawn's autoplay therefore
 * never fires scroll events, and the fade never triggers.
 *
 * This controller takes over the visible state directly:
 *   - Toggles aria-hidden on each slide
 *   - Toggles the active dot class + aria-current
 *   - Drives autoplay via a plain interval (respects reduced motion)
 *   - Pauses on hover / focus and on the explicit play/pause button
 *
 * Dawn's own listeners stay attached, but they call scrollTo on a
 * non-scrollable container — a harmless no-op.
 */
(function () {
  function initSlideshow(root) {
    if (!root || root.dataset.beauteplusFadeInit === '1') return;

    var slider = root.querySelector('.slideshow.slider');
    if (!slider) return;

    var slides = slider.querySelectorAll('.slideshow__slide');
    if (slides.length <= 1) {
      root.dataset.beauteplusFadeInit = '1';
      return;
    }

    var dots = root.querySelectorAll('.slider-counter__link');
    var prevBtn = root.querySelector('.slider-button--prev');
    var nextBtn = root.querySelector('.slider-button--next');
    var autoplayBtn = root.querySelector('.slideshow__autoplay');

    var autoplayEnabled = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.dataset.speed, 10);
    if (isNaN(speed) || speed <= 0) speed = 5;
    speed = speed * 1000;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;
    var paused = false;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('tabindex', '-1');
        }
        var links = slide.querySelectorAll('a, button');
        links.forEach(function (el) {
          if (active) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });
      });

      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('slider-counter__link--active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      current = index;
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function start() {
      if (!autoplayEnabled || paused || reducedMotion) return;
      stop();
      timer = window.setInterval(next, speed);
    }

    function stop() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function setPaused(value) {
      paused = value;
      if (paused) stop();
      else start();
      if (autoplayBtn) {
        autoplayBtn.classList.toggle('slideshow__autoplay--paused', paused);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        prev();
        if (!paused) start();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        next();
        if (!paused) start();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        show(i);
        if (!paused) start();
      });
    });

    if (autoplayBtn) {
      autoplayBtn.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        setPaused(!paused);
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () {
      if (!paused) start();
    });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function () {
      if (!paused) start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (!paused) start();
    });

    show(0);
    root.dataset.beauteplusFadeInit = '1';
    if (autoplayEnabled) start();
  }

  function initAll() {
    document.querySelectorAll('slideshow-component').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('slideshow-component');
    if (root) initSlideshow(root);
  });
})();
